export default "<img src=\"assets/img/Picture2.png\" alt=\"sponsorship\" class=\"sponsorship mt-4 mb-2\">"